import { SystemError } from './system-error';

export async function tryExecute<T>(task: () => T | Promise<T>, errorMessage: string, errorTitle?: string, errorAmbient?: boolean) {
  try { return await task(); }
  catch (e) { throw new SystemError(errorMessage, errorTitle, e, errorAmbient); }
}

export function errorReplacer(key, value) {
  if (value instanceof Error) {
    const error = {};
    Object.getOwnPropertyNames(value).forEach(key => error[key] = value[key]);
    return error;
  }

  return value;
}
